import { Navigate, Outlet } from "react-router-dom";
import { usePasswordResetContext } from "../contexts/PasswordResetContex";

const OtpAndResetProtectedRoute = () => {
  const { email } = usePasswordResetContext();

  if (!email) {
    return <Navigate to="/auth/change-password" replace />;
  }

  return <Outlet />;
};

export default OtpAndResetProtectedRoute;
